import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { getCookie, setCookie } from './api/common'

//组件模块






//pub----
import AutoLogin from './components/AutoLogin'
import Login from './components/Login'
import Reg from './components/Reg'
import Tip from './components/Tip'
import FindUpassByEmail from './components/FindUpassByEmail'


import Header from './components/web/Header'

//myset----
import MySet from './components/web/MySet/MySet'
import Upfaceimg from './components/web/MySet/Upfaceimg'
import EditUinfo from './components/web/MySet/EditUinfo'
import UpUpass from './components/web/MySet/UpUpass'
//mymessage----
import Message from './components/web/MyMessage/Message'
import MyMessageLeft from './components/web/MyMessage/MyMessageLeft'
//index----
import Forum from './components/web/index/Forum'
import ReleaseForumSucc from './components/web/index/ReleaseForumSucc'
import ForumDetail from './components/web/index/ForumDetail'
import ForumLeft from './components/web/index/ForumLeft'
//search---
import SearchLeft from './components/web/Search/SearchLeft'
import SearchUser from './components/web/Search/SearchUser'
import SearchForum from './components/web/Search/SearchForum'
//team===
import Teamer from './components/web/Team/Teamer'
import TeamerAdd from './components/web/Team/TeamerAdd'
import TeamForum from './components/web/Team/TeamForum'


//myhome
import Fans from './components/web/AuthorHome/Fans'
import Home from './components/web/AuthorHome/Home'
import Comments from './components/web/AuthorHome/Comments'
import AuthorLeft from './components/web/AuthorHome/AuthorLeft'

//admin----
import AdminType from './components/admin/Type'
import AdminForum from './components/admin/Forum'
import AdminUsers from './components/admin/Users'
import AdminWaitShUsers from './components/admin/WaitShUsers'
import AdminComment from './components/admin/Comment'
import EntityList from './components/admin/List'
import AdminRegion from './components/admin/Region'
import AdminEmail from './components/admin/Email'
import AdminTemplate from './components/admin/Template'
import AdminOutbox from './components/admin/Outbox'
import AdminSendRecord from './components/admin/SendRecord'



Vue.use(Router)




const router = new Router({
    //mode: 'history',
    mode: 'hash',

    routes: [

        {
            path: '/',
            name: 'Header',
            component: Header,
            redirect: '/AutoLogin',
            children: [
                { path: '/Index', name: 'Index', component: Forum },
                { path: '/Forum', name: 'Forum', component: Forum },
                { path: '/ReleaseForumSucc', name: 'ReleaseForumSucc', component: ReleaseForumSucc },
                { path: '/ForumDetail', name: 'ForumDetail', component: ForumDetail },
                { path: '/ForumLeft', name: 'ForumLeft', component: ForumLeft },
                { path: '/MyMessageLeft', name: 'MyMessageLeft', component: MyMessageLeft },


                { path: '/SearchLeft', name: 'SearchLeft', component: SearchLeft },
                { path: '/SearchUser', name: 'SearchUser', component: SearchUser },
                { path: '/SearchForum', name: 'SearchForum', component: SearchForum },

                { path: '/Teamer', name: 'Teamer', component: Teamer },
                { path: '/TeamerAdd', name: 'TeamerAdd', component: TeamerAdd },
                { path: '/TeamForum', name: 'TeamForum', component: TeamForum },

                { path: '/Fans', name: 'Fans', component: Fans },
                { path: '/Home', name: 'Home', component: Home },
                { path: '/Comments', name: 'Comments', component: Comments },
                { path: '/AuthorLeft', name: 'AuthorLeft', component: AuthorLeft },

                { path: '/MySet', name: 'MySet', component: MySet },
                { path: '/Upfaceimg', name: 'Upfaceimg', component: Upfaceimg },
                { path: '/EditUinfo', name: 'EditUinfo', component: EditUinfo },
                { path: '/UpUpass', name: 'UpUpass', component: UpUpass },



                { path: '/Message', name: 'Message', component: Message },


            ]
        },
        { path: '/Login', name: 'Login', component: Login },
        { path: '/Reg', name: 'Reg', component: Reg },
        { path: '/Tip', name: 'Tip', component: Tip },
        { path: '/AutoLogin', name: 'AutoLogin', component: AutoLogin },
        { path: '/FindUpassByEmail', name: 'FindUpassByEmail', component: FindUpassByEmail },



        { path: '/AdminType', name: 'AdminType', component: AdminType },
        { path: '/AdminUsers', name: 'AdminUsers', component: AdminUsers },
        { path: '/AdminWaitShUsers', name: 'AdminWaitShUsers', component: AdminWaitShUsers },
        { path: '/AdminForum', name: 'AdminForum', component: AdminForum },
        { path: '/AdminComment', name: 'AdminComment', component: AdminComment },
        { path: '/EntityList', name: 'EntityList', component: EntityList },
        { path: '/AdminRegion', name: 'AdminRegion', component: AdminRegion },
        { path: '/AdminEmail', name: 'AdminEmail', component: AdminEmail },
        { path: '/AdminTemplate', name: 'AdminTemplate', component: AdminTemplate },
        { path: '/AdminOutbox', name: 'AdminOutbox', component: AdminOutbox },
        { path: '/AdminSendRecord', name: 'AdminSendRecord', component: AdminSendRecord },




    ],


})

router.beforeEach((to, form, next) => {
    let sn = to.path.toLowerCase();
    let li = ['login', 'reg', 'tip', 'autologin', 'findupassbyemail']; //不用拦截的链接


    let num = 0;
    for (let i = 0; i < li.length; i++) {
        if (sn.indexOf(li[i]) > -1) num++;
    }
    if (num == 0) {
        let lustr = '';
        //登录拦截
        try {
            lustr = store.state.logininfo;
            if (lustr.trim().length == 0) {
                if ((getCookie('uid') != undefined && getCookie('token') != undefined) || (sessionStorage.uid != undefined && sessionStorage.token != undefined)) {
                    sessionStorage.tol = to.fullPath;
                    setCookie("tol", to.fullPath, null);
                    next({ path: '/AutoLogin' });
                    return;
                } else if (localStorage.autologin == 1 && ((getCookie('uid') != undefined && getCookie('token') != undefined) || (localStorage.uid != undefined && localStorage.token != undefined))) {
                    sessionStorage.tol = to.fullPath;
                    setCookie("tol", to.fullPath, null);
                    next({ path: '/AutoLogin' });
                    return;
                } else {
                    sessionStorage.tol = to.fullPath;
                    next({ path: '/Login' })
                    return;
                }
            }
        } catch (e) {
            sessionStorage.tol = to.fullPath;
            setCookie("tol", to.fullPath, null);
            next({ path: '/Login' })
            return;
        }
        //后台权限拦截

        if (sn.indexOf("admin") > -1) {

            let lander = JSON.parse(lustr);

            if (lander.role == '100') {
                next();
                return;
            } else if (lander.role == '50') {
                if (sn.indexOf("adminforum") > -1 || sn.indexOf("adminusers") > -1 || sn.indexOf("admincomment") > -1) {
                    next();
                    return;
                }
            }

            console.log("p0op")
            sessionStorage.systip = "暂无权限";
            sessionStorage.removeItem("tol");
            next({ path: '/Tip' })
            return;

        }

        next();
    }
    next();
})

export default router